module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}



/*****************
 ** WEBPACK FOOTER
 ** ../~/xtend/immutable.js
 ** module id = 1024
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/xtend/immutable.js
 ** module id = 1024
 ** module chunks = 1
 **/